// extracted by mini-css-extract-plugin
export default {"example":"example-sRWC5","fullWidth":"fullWidth-mrlQa"};